module.exports = __webpack_public_path__ + "prod/20260903163609/img/ecology.1a964161.png";